import { Avatar, CardHeader, Typography } from "@mui/material";

interface SubTitleProps {
  title: string;
}

export const SubTitle = ({ title }: SubTitleProps) => {
  return <Typography variant="h4">{title}</Typography>;
};

interface SubTitleWithImageProps {
  url: string;
  title: string;
}

export const SubTitleWithImage = ({ url, title }: SubTitleWithImageProps) => {
  return (
    <CardHeader
      sx={{ padding: "6px" }}
      titleTypographyProps={{
        fontWeight: "100px",
        fontSize: "25px",
      }}
      avatar={<Avatar src={url} alt={title.toUpperCase()} />}
      title={title}
    />
  );
};
